export function bodyOverflowHidden(condition) {
    window.document.body.style.overflow = condition ? 'hidden' : '';
}
